import { Controller } from "@hotwired/stimulus"
import { errorDialog } from '../helpers/swal_helper';

export default class extends Controller {
  toggleCheque(event) {
    const value = event.target.value;
    document.getElementById("cheque_field").style.display = value === "cheque" ? "block" : "none";
  }

  submit(event) {
    event.preventDefault();

    const form = event.target;
    const amounts = {};
    let isValid = true;
    let errorMessages = [];
    const submitButton = form.querySelector("[type='submit']");

    this.element.querySelectorAll(".std_amount").forEach(input => {
      const value = input.value.trim();
      const studentId = input.dataset.studentId;

      if (!value || isNaN(value)) {
        isValid = false;
        errorMessages.push(`Amount for student ID ${studentId} must be a valid number.`);
      } else {
        amounts[studentId] = value;
      }
    });

    if (!isValid) {
      errorDialog("Validation Error", errorMessages.join(", "))
      .then(() => {
        submitButton.disabled = false;
      });
      return;
    }

    const params = new URLSearchParams();
    params.append("payment_type", form.querySelector("[name='payment_type']").value);
    params.append("payment_from", form.querySelector("[name='payment_from']").value);
    params.append("payment_term", form.querySelector("[name='payment_term']").value);
    params.append("book_number", form.querySelector("[name='book_number']").value);
    params.append("receipt_number", form.querySelector("[name='receipt_number']").value);
    params.append("cheque_number", form.querySelector("[name='cheque_number']").value);
    params.append("new_values", JSON.stringify(amounts));

    const urlWithParams = `${form.action}?${params.toString()}`;

    fetch(urlWithParams, {
      method: "PATCH",
      headers: {
        "Accept": "text/javascript",
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content")
      }
    })
    .then(response => {
      if (submitButton) submitButton.disabled = false;

      if (!response.ok) {
        throw new Error(`Request failed: ${response.status}`);
      }

      return response.text().then(js => {
        const script = document.createElement("script");
        script.textContent = js;
        document.body.appendChild(script);
        document.body.removeChild(script);
      });
    })
    .catch(error => {
      if (submitButton) submitButton.disabled = false;
      errorDialog("Error", "Something went wrong.");
      console.error("Fetch Error:", error);
    });
  }
  reset() {
    const form = this.element.querySelector("form");
    if (form) form.reset();
  }
}
